




















































































































































































































import { Advertisement } from "@/interfaces/advertisement";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>,
    advertisement: Object as PropType<Advertisement>,
  },
  data() {
    return {
      active: false,
      cardStatus: "initial",
      bankStatus: "initial",
      paymentMode: null,
      cardHolderEmail: "",
      cardHolderHomePhoneNumber: "",
    };
  },
  methods: {
    async exec() {
      if (!this.publishmentOrder) {
        return;
      }

      this.startPayment(false);
    },
    async startPayment(use3ds: boolean) {
      use3ds = !!use3ds;
      this.cardStatus = "proceeding";
      window.pop.show();
      const paymentKey = await this.issuePaymentKey(use3ds);
      if (!("" + paymentKey).length) {
        setTimeout(() => {
          window.pop.hide();
          this.cardStatus = "failure";
        }, 5000);
        return;
      }
      window.pop.pay(paymentKey, {
        onSuccess: () => {
          this.$emit("success");
          this.active = false;
        },
        onFailure: () => {
          this.cardStatus = "failure";
          (this.$refs["modal"] as any).resumeExecuteButton();
        },
        onIncomplete: () => {
          this.cardStatus = "incomplete";
          (this.$refs["modal"] as any).resumeExecuteButton();
        },
      });
    },
    async issuePaymentKey(use3ds: boolean) {
      if (this.publishmentOrder.id) {
        if (use3ds) {
          return await this.$store.dispatch("post", [
            "/api/adv/issue_payment_key/" + this.publishmentOrder.id,
            {
              card: 1,
              cardHolderEmail: this.cardHolderEmail,
              cardHolderHomePhoneNumber: this.cardHolderHomePhoneNumber,
            },
          ]);
        } else {
          return await this.$store.dispatch("post", [
            "/api/adv/issue_payment_key/" + this.publishmentOrder.id,
          ]);
        }
      }
    },
    async bankTransfer() {
      if (this.publishmentOrder.id) {
        await this.$store.dispatch("post", [
          this.publishmentOrder["@id"] + "/payment/bank_transfer",
        ]);
        this.bankStatus = "success";
      }
    },
    async successfullyClose() {
      this.$emit("success");
      this.active = false;
    },
  },
  computed: {
    cancellable(): boolean {
      return this.bankStatus !== "success";
    },
  },
});
